var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.271 3.626a.646.646 0 0 0-.645.645V19.53c0 .356.29.645.645.645h8.9a.626.626 0 0 1 0 1.252h-8.9a1.898 1.898 0 0 1-1.897-1.897V4.27c0-1.047.85-1.897 1.897-1.897h8.9a.626.626 0 1 1 0 1.252h-8.9Zm12.272 2.749a.626.626 0 0 1 .886 0l5.049 5.049c.134.115.22.286.22.476v.002c0 .16-.061.321-.184.444L17.43 17.43a.626.626 0 0 1-.886-.885l4.02-4.02H9.357a.626.626 0 0 1 0-1.252h11.2L16.544 7.26a.626.626 0 0 1 0-.885Z",
    fill: "currentColor"
  })));
};
export default SvgLogout;